export default function Features() {
  const features = [
    {
      icon: 'ri-code-s-slash-line',
      title: 'Universal Rule Format',
      description: 'Write your lint rules once in a simple, language-agnostic format that works everywhere',
      color: '#00d9ff'
    },
    {
      icon: 'ri-git-branch-line',
      title: 'Multi-Language Export',
      description: 'Export your rules to ESLint, Pylint, RuboCop, Rustfmt, Golint, and more with a single command',
      color: '#8b5cf6'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Rule Comparison',
      description: 'Easily compare and manage differences in lint configurations across multiple projects',
      color: '#00d9ff'
    },
    {
      icon: 'ri-team-line',
      title: 'Team Sync',
      description: 'Share configurations with your team and keep everyone on the same page',
      color: '#8b5cf6'
    },
    {
      icon: 'ri-terminal-box-line',
      title: 'CLI & API',
      description: 'Powerful command-line interface and programmatic API for automation and integration',
      color: '#00d9ff'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Type Safe',
      description: 'Built with TypeScript for maximum reliability and excellent developer experience',
      color: '#8b5cf6'
    }
  ];

  const languages = [
    { name: 'JavaScript', icon: 'ri-javascript-line', tool: 'ESLint' },
    { name: 'TypeScript', icon: 'ri-code-line', tool: 'TSLint' },
    { name: 'Python', icon: 'ri-code-s-slash-line', tool: 'Pylint' },
    { name: 'Ruby', icon: 'ri-code-line', tool: 'RuboCop' },
    { name: 'Rust', icon: 'ri-code-s-slash-line', tool: 'Rustfmt' },
    { name: 'Go', icon: 'ri-code-line', tool: 'Golint' },
    { name: 'Java', icon: 'ri-code-s-slash-line', tool: 'Checkstyle' },
    { name: 'C++', icon: 'ri-code-line', tool: 'Clang-Tidy' }
  ];

  return (
    <section id="features" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#8b5cf6]/5 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#00d9ff]/10 border border-[#00d9ff]/30 px-4 py-2 rounded-full mb-6">
            <i className="ri-star-line text-[#00d9ff]"></i>
            <span className="text-[#00d9ff] text-sm font-medium">Features</span>
          </div>
          <h2 className="text-5xl font-bold text-white mb-6 font-['Space_Grotesk']">
            Everything You Need
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Powerful features designed to make linter management effortless across your entire tech stack
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-white/10 rounded-2xl p-8 hover:border-white/20 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div
                className="w-14 h-14 rounded-xl flex items-center justify-center mb-6 transition-all duration-300"
                style={{ backgroundColor: `${feature.color}15` }}
              >
                <i className={`${feature.icon} text-3xl`} style={{ color: feature.color }}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-white/10 rounded-3xl p-12">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-white mb-4 font-['Space_Grotesk']">
              Works With Your Stack
            </h3>
            <p className="text-gray-400">
              Bellibutton supports all major programming languages and their linting tools
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {languages.map((lang, index) => (
              <div
                key={index}
                className="bg-[#0a0a0a] border border-white/10 rounded-xl p-6 hover:border-[#00d9ff]/50 transition-all duration-300 hover:transform hover:scale-105 cursor-pointer"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-[#00d9ff]/20 to-[#8b5cf6]/20 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${lang.icon} text-2xl text-[#00d9ff]`}></i>
                </div>
                <h4 className="text-white font-semibold mb-1">{lang.name}</h4>
                <p className="text-gray-500 text-sm">{lang.tool}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
